import { useEffect } from 'react';
import cn from 'classnames';

import s from './mesh-gradient.module.css';

const MeshGradient = ({ style, className = '' }) => {
  useEffect(() => {
    // @ts-ignore
    import('./raw').then(({ gradient }) => gradient.initGradient('#gradient-canvas'));
  }, [style]);

  return (
    <canvas
      id="gradient-canvas"
      className={cn('w-full h-full', className, s.base, { [s.canvas]: !style })}
      style={style || null}
      data-js-darken-top
      data-transition-in
    />
  );
};

MeshGradient.defaultProps = {
  style: false
};

export default MeshGradient;
